import { getInteractionsFromTopicAndState } from 'selectors/block';
import { Action, initialState, State } from 'store/store';

export const updateInteractionsOpen = (
  state: State = initialState,
  { data }: Action
): State => {
  const { blocks, currentTopic, interactionsOpen, nextInteractionMap } = state;
  const currentInteractionId = (data as unknown) as string;

  // interactions in currentTopic
  // get the next interaction.id based on ( current ) data.id
  // add it to the list. . .

  // add the ability to update with an array

  if (Array.isArray(data)) {
    const newInteractionsOpen = Array.from(
      new Set([...interactionsOpen, ...data])
    );

    return {
      ...state,
      interactionsOpen: newInteractionsOpen,
    } as any;
  }

  // const interactions = getInteractionsFromTopicAndState(
  //   state as any,
  //   (Object.values(blocks) as any).find(($: any) => $.id === currentTopic)
  // );

  // const nextInteraction =
  //   interactions[interactions.findIndex((i: any) => i.id === data) + 1];

  // if (!nextInteraction) return state;

  // const nextInteractionId = nextInteraction && nextInteraction.id;

  const nextInteractionId = nextInteractionMap[currentInteractionId];
  // console.log(data, nextInteractionId);

  if (!nextInteractionId) {
    return state;
  }

  if (interactionsOpen.includes(nextInteractionId)) {
    return state;
  } else {
    return {
      ...state,
      interactionsOpen: [...interactionsOpen, nextInteractionId],
    } as any;
  }
};
